// Current palette
export const weaveBlue = '#37CFF1';
export const mediumBlue = '#24B7DB';
export const darkBlue = '#0098BA';
export const notificationRed = '#D52B2B';
export const orange = '#ED9824';
export const pink = '#E73087';
export const actionGreen = '#2BD53C';
export const modalBackgroundColor = 'rgba(51, 65, 72, 0.9)'; // #334148e6
export const headerText = '#334148';

// Grayscale colors are orded from Black to White
export const black = '#000000'; // 100% black
export const headline = '#28343C';
export const gray2 = '#312B2B';
export const gray3 = '#484848';
export const gray4 = '#666666';
export const gray7 = '#777777'; // 50% black
export const gray8 = '#6E7D85';
export const gray9 = '#93A1A8';
export const gray11 = '#D4DBDF';
export const gray13 = '#EDF0F1';
export const gray14 = '#F5F7F7';
export const gray16 = '#F4F6F6';
export const gray17 = '#FBFBFB';
export const white = '#FFFFFF'; // 0% black
// End grayscale colors

// Analytics Colors
export const gradientBlue = 'rgb(47, 200, 239)';
export const gradientGreen = 'rgb(40, 206, 69)';
export const gradientOrange = 'rgb(236, 103, 39)';
export const gradientRed = 'rgb(238, 51, 51)';
export const gradientYellow = 'rgb(238, 162, 75)';
export const trendGreen = 'rgb(42, 203, 136)';
export const darkGrey = 'rgb(55, 67, 74)';
export const lightGrey = 'rgb(220, 225, 229)';
export const textGrey = '#93A1A8';
export const textDarkGrey = '#D8D8D8';
export const backroundGrey = '#979797';
export const borderGrey = '#d1d9dd';
export const borderHover = '#4c5e67';
export const fontGrey = 'rgb(189, 197, 201)';
export const green = 'rgb(43, 213, 60)';
export const emptyMeterGray = 'rgb(191, 203, 210)';
export const hotPink = 'rgb(255, 0, 140)';
export const electricBlue = 'rgb(0, 208, 244)';
export const fadeBlue1 = electricBlue;
export const fadeBlue2 = 'rgb(52, 217, 245)';
export const fadeBlue3 = 'rgb(128, 231, 250)';
export const fadeBlue4 = 'rgb(178, 240, 251)';
export const fadeBlue5 = 'rgb(203, 246, 253)';
